import { ref, watch } from 'vue'
import { useAuthStore } from '@/features/account/session'
import { useAppearanceStore } from '@/features/appearance/store'
import { themes } from '@/lib/themes'

export function useAppearanceSession() {
  const auth = useAuthStore()
  const store = useAppearanceStore()
  const appearanceLoading = ref(false)
  let accountLoad = 0
  // Gate the route only while establishing an account's initial appearance.
  // Editor retries use store.loading and must leave the active route mounted.
  watch(() => auth.userId, async id => {
    const request = ++accountLoad
    appearanceLoading.value = !!id
    await store.load(id)
    if (request === accountLoad) appearanceLoading.value = false
  }, { immediate: true, flush: 'sync' })
  watch(() => store.saved.app.themeId, id => {
    const theme = themes[id]
    for (const [key, value] of Object.entries(theme.vars)) document.documentElement.style.setProperty(key, value)
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme.preview.bg)
  }, { immediate: true, flush: 'sync' })
  return { appearanceLoading }
}
